import styles from './Separator.module.scss';

export function Separator(): React.ReactElement {
  return <div className={styles.separator} />;
}
